export interface FrameTimeReport {
  samples: number;
  durationMs: number;
  averageFps: number;
  p95Ms: number;
  p99Ms: number;
  longFramesOver50Ms: number;
  longFramesPerMinute: number;
}

export class FrameTimeDistribution {
  private readonly values: number[] = [];
  private totalMs = 0;

  add(frameMs: number): void {
    if (!Number.isFinite(frameMs) || frameMs < 0) return;
    this.values.push(frameMs);
    this.totalMs += frameMs;
  }

  report(): FrameTimeReport {
    const sorted = [...this.values].sort((a, b) => a - b);
    const longFrames = sorted.filter((value) => value > 50).length;
    const durationMinutes = this.totalMs / 60_000;
    return {
      samples: sorted.length,
      durationMs: this.totalMs,
      averageFps: this.totalMs > 0 ? (sorted.length * 1_000) / this.totalMs : 0,
      p95Ms: percentile(sorted, 0.95),
      p99Ms: percentile(sorted, 0.99),
      longFramesOver50Ms: longFrames,
      longFramesPerMinute: durationMinutes > 0 ? longFrames / durationMinutes : 0,
    };
  }

  reset(): void {
    this.values.length = 0;
    this.totalMs = 0;
  }
}

function percentile(sorted: readonly number[], quantile: number): number {
  if (sorted.length === 0) return 0;
  const index = Math.min(sorted.length - 1, Math.ceil(sorted.length * quantile) - 1);
  return sorted[index]!;
}
